import moment from 'moment'
import request from '@/utils/request'

// 上报埋点数据
export function reportData(data) {
  // 测试环境不上报
  // if (!$config.isOnline && !data.debug)
  //   return

  const { custId, custName } = JSON.parse(localStorage.getItem('userInfo') || null) || {}
  data = {
    dataSource: 'OLS', // 订单数据来源：OBC-代订舱，OLS-旧网服，BCS-海运系统
    custId,
    custName,
    pageName: window.document.title,
    pageUrl: window.location.href,
    buttonName: '提交',
    endTime: currentTime(),
    ...data,
  }

  request({
    url: '/web/www/operation/save',
    method: 'post',
    data,
  }).catch(console.warn)
}

// 获取当前时间
export function currentTime(fmt = 'YYYY-MM-DD HH:mm:ss') {
  return moment(Date.now()).format(fmt)
}
